import { PageHeaderProps } from "@made-people/blueprint-page-header";

/**
 * In this file you can specify default props for components that render,
 * which have been wrapped with withManagedProps
 */

export const PageHeader: PageHeaderProps = {
  template: "krakow",
  textBlock: {
    heading: {
      variants: {
        headingSize: { initial: "xl", md: "2xl", lg: "2xl" },
      },
    },
    layout: {
      spacing: {
        applySpacing: "false",
      },
    },
  },
  breadcrumbsSettings: {
    layout: {
      spacing: {
        applySpacing: "false",
      },
    },
  },
  linkShortcuts: {
    layout: {
      spacing: {
        applySpacing: "false",
      },
      position: {
        applyPosition: "false",
      },
    },
  },
  layout: {
    spacing: {
      y: { initial: "sm", lg: "2xl" },
    },
    position: {
      maxWidth: "xl",
    },
  },
};
